var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.452759C8.34136 0.452759 3.66324 3.2751 0.211261 7.85933C-0.0704204 8.2349 -0.0704204 8.7596 0.211261 9.13518C3.66324 13.7249 8.34136 16.5473 13.5 16.5473C18.6586 16.5473 23.3368 13.7249 26.7887 9.1407C27.0704 8.76512 27.0704 8.24043 26.7887 7.86485C23.3368 3.2751 18.6586 0.452759 13.5 0.452759ZM13.8701 14.1668C10.4457 14.3822 7.61783 11.5598 7.83323 8.12996C8.00997 5.3021 10.3021 3.00999 13.1299 2.83324C16.5543 2.61784 19.3822 5.44018 19.1668 8.87007C18.9845 11.6924 16.6924 13.9845 13.8701 14.1668ZM13.6988 11.5488C11.8541 11.6648 10.3297 10.1459 10.4512 8.30118C10.5451 6.77679 11.7823 5.54512 13.3067 5.4457C15.1514 5.32972 16.6758 6.84859 16.5543 8.69333C16.4549 10.2232 15.2177 11.4549 13.6988 11.5488Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.c84c8375.svg";
export { ForwardRef as ReactComponent };